import { EventEditionDetails, ICMSApiResponse } from "../../types";
import store from "../../../redux/store";
import EventHelper from "../../network/helpers/event/EventHelper";

class CMSHelper {
  getPortalImageUrl = (logoUrl: string, baseUrl: string, imageName: string, sku: string) => {
    const NUMBER_OF_DIRECTORIES = 5;
    const splitLogoUrl = logoUrl.split("/");
    const rmIndex = splitLogoUrl.indexOf("content");
    return `${baseUrl}/${splitLogoUrl
      .slice(rmIndex, rmIndex + NUMBER_OF_DIRECTORIES)
      .join("/")}/badge/${sku.toLowerCase()}/${imageName}.jpg/_jcr_content/renditions/original./123/${imageName}.jpg`;
  };

  getCmsImageUrl = (productSku: string, imageName: string, eventEdition: EventEditionDetails, badgeLocation: ICMSApiResponse) => {
    const eventLogoUrl = badgeLocation.siteDetails.logo.url;
    const domain = new URL(eventEdition.domain || "").origin;

    return this.getPortalImageUrl(eventLogoUrl, domain, imageName, productSku);
  };

  getReceiptLogoUrl = async (locale: string) => {
    const cmsEventDetails = store.getState().eventEdition.cmsEventDetails;
    const logoPath = cmsEventDetails?.siteDetails?.logo.url;
    const domain = new URL(EventHelper.eventEdition?.domain || "").origin;

    const NUMBER_OF_DIRECTORIES = 5;
    const splitLogoUrl = logoPath.split("/");
    const rmIndex = splitLogoUrl.indexOf("content");
    return `${domain}/${splitLogoUrl
      .slice(rmIndex, rmIndex + NUMBER_OF_DIRECTORIES)
      .join("/")}/receipts/${locale.toLowerCase()}.jpg/_jcr_content/renditions/original./123/${locale.toLowerCase()}.jpg`;
  };
}

export default new CMSHelper();
